import { RemovableRef, useLocalStorage } from '@vueuse/core';
import { defineStore } from 'pinia';
interface State {
  inviteCodes: RemovableRef<Map<string, string>>;
}

export const useDataStore = defineStore('data', {
  state: (): State => ({
    inviteCodes: useLocalStorage('pinia/data/inviteCodes', new Map()),
  }),
  getters: {
    getInviteCode: (state) => {
      return (invitePDA: string): string | undefined =>
        state.inviteCodes.get(invitePDA);
    },
  },
  actions: {
    async fetch() {},
    setInviteCode(invitePDA: string, code: string) {
      this.inviteCodes.set(invitePDA, code);
    },
  },
});
